import { render } from "./TicketMain.vue?vue&type=template&id=80899868"
import script from "./TicketMain.vue?vue&type=script&lang=js"
export * from "./TicketMain.vue?vue&type=script&lang=js"

import "./TicketMain.vue?vue&type=style&index=0&id=80899868&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__